import PropTypes from 'prop-types';
import React from 'react';

import {SEGREGATION_TOOLTIP} from '../../constants/parameterization';
import {MERCADO_PAGO, PAY_GO} from '../../constants/psrs';
import {useGetParameterization} from '../../hooks/useGetParameterization';
import {useParameterizationStore} from '../../store/slices/parameterizationStore';
import {positionInTheArray} from '../../utils';
import {AleloCards} from '../AleloCards';
import {InputCodePsr} from '../InputCodePsr/InputCodePsr';
import LogoPsr from '../LogoPsr';
import './PsrCard.style.scss';

const PsrCard = (props) => {
  const segregationTooltip = useParameterizationStore(
    (state) => state.segregationTooltip
  );

  useGetParameterization(SEGREGATION_TOOLTIP);

  const showSegregationInfo = () => {
    return segregationTooltip && props.psrItem.isIpRule;
  };

  const hasError = () =>
    positionInTheArray(props.haveErrorIntoListPsr, props.psrItem.id) !== -1;

  const getTooltipMessage = () => {
    switch (props.psrItem.id) {
      case PAY_GO:
        return 'Habilitações apenas para as maquininhas do modelo D195 e S920, confirme o modelo antes de habilitar!';
      case MERCADO_PAGO:
        return 'Habilitações apenas para as maquininhas do modelo Pro1, Pro2, Smart2 e Mini chip, confirme o modelo antes de habilitar!';
      default:
        return '';
    }
  };

  return (
    <div
      className="psr-card"
      id={`psr-card-${props.psrItem.id}`}
      data-testid="psr-card"
    >
      <PsrCardHeader psrItem={props.psrItem} />
      <PsrCardBody {...props} hasError={hasError()} />
      <PsrCardFooter
        psrItem={props.psrItem}
        showSegregationInfo={showSegregationInfo()}
        tooltip={getTooltipMessage()}
      />
    </div>
  );
};

const PsrCardHeader = ({psrItem}) => (
  <div className="psr-card__header">
    <div className="psr-card__logo">
      <LogoPsr psrId={psrItem.id} psrName={psrItem.name} />
    </div>
  </div>
);

const PsrCardBody = (props) => (
  <div className="psr-card__body">
    <div className="psr-card__input">
      <InputCodePsr
        psrItem={props.psrItem}
        psrCodeIsCnpj={props.psrCodeIsCnpj}
        psrCode={props.psrCode}
        haveErrorIntoListPsr={props.haveErrorIntoListPsr}
        setErrorIntoListPsr={props.setErrorIntoListPsr}
      />
      {props.hasError && <p className="psr-card__error">Número incorreto</p>}
    </div>
  </div>
);

const PsrCardFooter = ({psrItem, showSegregationInfo, tooltip}) => (
  <div className="psr-card__footer">
    <p className="psr-card__legend">
      Você poderá aceitar os seguintes cartões:
    </p>
    <div className="psr-card__cards">
      <AleloCards psr={psrItem} />
    </div>
    {tooltip && (
      <div className="psr-card__info psr-card__info--tooltip">
        <span className="psr-card__info-icon psr-card__info-icon--tooltip">
          ?
        </span>
        <span className="psr-card__info-text">{tooltip}</span>
      </div>
    )}
    {showSegregationInfo && (
      <div className="psr-card__info psr-card__info--segregation">
        <span className="psr-card__info-icon psr-card__info-icon--segregation">
          i
        </span>
        <span className="psr-card__info-text">
          Para que seja possível aceitar o <strong>Multibenefícios</strong>{' '}
          nesta maquininha, seu CNAE deve permitir a habilitação do produto{' '}
          <strong>Alimentação PAT/Auxílio</strong>.
        </span>
      </div>
    )}
  </div>
);

PsrCard.propTypes = {
  psrItem: PropTypes.object.isRequired,
  psrCodeIsCnpj: PropTypes.bool,
  psrCode: PropTypes.string,
  haveErrorIntoListPsr: PropTypes.array,
  setErrorIntoListPsr: PropTypes.func
};

PsrCardHeader.propTypes = {
  psrItem: PropTypes.object.isRequired
};

PsrCardBody.propTypes = {
  psrItem: PropTypes.object.isRequired,
  hasError: PropTypes.bool,
  psrCodeIsCnpj: PropTypes.bool,
  psrCode: PropTypes.string,
  haveErrorIntoListPsr: PropTypes.array,
  setErrorIntoListPsr: PropTypes.func
};

PsrCardFooter.propTypes = {
  psrItem: PropTypes.object.isRequired,
  showSegregationInfo: PropTypes.bool,
  tooltip: PropTypes.string
};

export default PsrCard;
